<template>
	<div v-if="project">
		<div class="header">
			<h3 class="primary--text text-lg-left mb-2 header-title">
				{{ $t('project-detail.menu.routes') }}
				<v-btn text rigth class="ml-3" @click="filterOpen = !filterOpen">
					{{ $t('projects.filter') }}
					<v-icon right dark>filter_list</v-icon>
				</v-btn>
			</h3>
			<v-container grid-list-md text-xs-right v-if="filterOpen">
				<v-form ref="form" class="xs12">
					<v-layout row wrap>
						<template>
							<v-flex xs12 md3>
								<v-select light clearable lazy filled v-model="filter.method" :items="methodOptions"
													:label="$t('projects.routes.method')"></v-select>
							</v-flex>
							<v-flex xs12 md9>
								<v-text-field light lazy filled v-model="filter.endpoint"
															:label="$t('projects.routes.endpoint')"></v-text-field>
							</v-flex>
						</template>
					</v-layout>
				</v-form>
			</v-container>
		</div>

		<v-container grid-list-md text-xs-right class="swagger-ui">
			<route-list-item v-for="endpoint in filteredRoutes" :endpoint="endpoint" :key="endpoint._id"
											 @save="updateEndpoint" @removeEndpoint="removeEndpoint">
				>
			</route-list-item>
			<route-list-item :endpoint="emptyEndpoint" @save="createEndpoint">
			</route-list-item>
		</v-container>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RouteListItem from './route-list-item';

export default {
	name: 'RouteList',
	components: { RouteListItem },
	data() {
		return {
			filterOpen: false,
			methodOptions: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
			filter: {},
		};
	},
	computed: {
		...mapState({
			project: state => state.project.projectDetail
		}),
		emptyEndpoint() {
			return {
				method: '+',
				path: this.$t('projects.routes.add-new-endpoint')
			};
		},
		filteredRoutes() {
			let routes = [];
			if (this.project.endpoints) routes = JSON.parse(JSON.stringify(this.project.endpoints));
			if (this.filterOpen && this.filter.method) {
				routes = routes.filter(e => e.method === this.filter.method);
			}
			if (this.filterOpen && this.filter.endpoint) {
				routes = routes.filter(e => e.endpoint.includes(this.filter.endpoint));
			}
			return routes.sort((a, b) => {
				if (a.endpoint === b.endpoint) {
					return a.method > b.method ? -1 : 1;
				}
				return a.endpoint < b.endpoint ? -1 : 1;
			});
		}
	},
	methods: {
		...mapActions({
			createEndpoint: 'project/createEndpoint',
			updateEndpoint: 'project/updateEndpoint',
			deleteEndpoint: 'project/deleteEndpoint'
		}),
		removeEndpoint(id) {
			this.deleteEndpoint(id);
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";
@import "swagger";

.v-subheader {
	min-height: 100px;
	padding: 20px;
	background-color: $light-grey;
}
</style>
